export class Sound {
  readonly name: string
  readonly version: number
  description: string

  constructor (name: string, version: number, description = '') {
    this.name = name
    this.version = version
    this.description = description
  }

  static fromJson (d: any) {
    return new Sound(d.name, d.version, d.description || '')
  }
}
